// 在线数据
import request from '@/utils/request';
export function onlineUsers(data) {
  return request({
    url: '/data/onlineusers',
    method: 'get',
    params: data
  });
}